import React from "react";
import classNames from "classnames";
import {FaBookBible} from "react-icons/fa6";
import {IoLibrary} from "react-icons/io5";

// Icon ghép cho "Thư Viện Công Giáo" - GHÉP 2 icon (sách = kho tài liệu (Kinh Thánh, văn kiện, từ
// điển... đã gộp chung vào đây, xem comment ở entry 'documents') + kính lúp = tra cứu/tìm kiếm trong
// kho đó) thành 1 hình.
//
// ĐÃ THỬ kiểu "icon nền + khoanh tròn badge riêng đè góc" (giống HymnIcon/LearnPlayIcon/DirectoryIcon)
// trước - đổi sang kiểu LỒNG THẬT (giống MassTimeTileIcon: nhà thờ nằm ngay trong bụng cái ghim, không
// khoanh tròn riêng) theo phản hồi thực tế: "cách lồng icon ở phần đánh dấu rất hay... không phải
// badge đơn thuần". Sách (FaBook) có mặt bìa khá rộng/đặc - đủ chỗ đặt kính lúp nhỏ ngay GIỮA bìa
// (kiểu "tra cứu trong sách") mà không cần khoanh tròn nền riêng để tách biệt, khác nốt nhạc (HymnIcon)
// - không có vùng đặc nào đủ rộng để lồng, phải giữ kiểu badge góc cũ.
// Icon kính lúp đổi từ FaMagnifyingGlass (nét đơn, không nền) sang IoSearchCircle (ĐÃ VẼ SẴN kính lúp
// trong 1 vòng tròn liền khối, đơn sắc) theo phản hồi thực tế "nên dùng cái có circle và fill" - tự
// thân icon đã đủ tương phản/rõ nét khi lồng lên sách mà không cần thêm khoanh tròn CSS riêng.
// `showBadge`: true (mặc định) - hiện đủ 2 icon lồng, đúng cỡ tuned cho sidebar (~size 30). Tắt
// (false) khi component này bị ĐEM DÙNG LẠI ở ngữ cảnh cỡ quá khác (icon mờ nền cỡ rất lớn, hoặc
// nhồi vào vòng tròn có sẵn quá nhỏ) - lúc đó chỉ hiện icon nền (sách), bỏ kính lúp vì ở cỡ lệch xa
// 30px, icon lồng bên trong dễ vỡ tỉ lệ/không đọc được - xem SectionHeroBanner (SpaceWebApps.js).
export const LibraryIcon = ({
                                size = 32,
                                bookColor = '#059669',    // emerald-600 - màu riêng cho "Thư Viện",
                                // phân biệt với gia đình (cam) / nhà thờ (teal) / học & chơi (tím) /
                                // thánh ca (chàm) / danh bạ (xanh dương)
                                searchColor = '#f59e0b',  // amber-500 - khác màu sách (xanh lá), CÙNG
                                // tông "badge" amber đã dùng cho icon phụ ở LearnPlayIcon/HymnIcon/
                                // DirectoryIcon, giữ nhất quán dù giờ không còn khoanh tròn CSS riêng
                                showBadge = true,
                                className,
                                style,
                                ...props
                            }) => (
    <div
        style={{width: size, height: size, backgroundColor: 'transparent', ...style}}
        className={classNames('flex-shrink-0 rounded-lg flex items-center justify-center', showBadge ? 'relative' : '', className)}
        {...props}>
        <IoLibrary
            size={size}
            style={{color: bookColor, filter: 'drop-shadow(0px 1px 1px rgba(0,0,0,0.2))'}}
        />
        {/*{showBadge && (*/}
        {/*    <PiCrossFill*/}
        {/*        size={size * 0.62}*/}
        {/*        style={{*/}
        {/*            color: searchColor,*/}
        {/*            position: 'absolute',*/}
        {/*            top: '38%',*/}
        {/*            left: '50%',*/}
        {/*            transform: 'translate(-50%, -50%)',*/}
        {/*            filter: 'drop-shadow(0px 1px 1px rgba(0,0,0,0.3))',*/}
        {/*        }}*/}
        {/*    />*/}
        {/*)}*/}
    </div>
);
